import Typography, { type TypographyProps } from "@mui/material/Typography";

/** Small, muted metadata text: counts, timestamps, fine print. */
export function Meta(props: TypographyProps) {
  return <Typography variant="caption" color="text.disabled" {...props} />;
}
